import React from "react";
import { ATTEMPT_STATUSES } from "@miplatform/constants";
import {
  EmailTemplateType,
  IAttemptListItemResponseForWorkOrder,
  IStep,
  StepType,
} from "@miplatform/types";
import { WorkOrderAttemptDocumentForm } from "../WorkOrderAttemptDocumentForm/WorkOrderAttemptDocumentForm";
import { WorkOrderAttemptEmailForm } from "../WorkOrderAttemptEmailForm";
import { WorkOrderDrawerGeneralStep } from "./WorkOrderDrawerGeneralStep";

export const WorkOrderAttemptStepDisplay = ({
  step,
  attempt,
  handleClose,
  getAttempt,
}: WorkOrderAttemptStepDisplayProps): React.ReactNode => {
  if (step.stepType === StepType.Email) {
    return (
      <WorkOrderAttemptEmailForm
        isViewMode={
          attempt?.attemptStatus !== ATTEMPT_STATUSES.STARTED &&
          attempt?.attemptStatus !== ATTEMPT_STATUSES.PENDING
        }
        attempt={attempt}
        step={step}
        templateType={EmailTemplateType.OrderSand}
        onClose={handleClose}
      />
    );
  }

  if (step.stepType === StepType.Document) {
    return (
      <WorkOrderAttemptDocumentForm
        isViewMode={
          attempt?.attemptStatus !== ATTEMPT_STATUSES.STARTED &&
          attempt?.attemptStatus !== ATTEMPT_STATUSES.PENDING
        }
        attempt={attempt}
        onClose={handleClose}
        onRefresh={getAttempt}
      />
    );
  }

  return <WorkOrderDrawerGeneralStep step={step} />;
};

interface WorkOrderAttemptStepDisplayProps {
  attempt: IAttemptListItemResponseForWorkOrder;
  step: IStep;
  handleClose: () => void;
  getAttempt: () => Promise<void> | void;
}
